import React from 'react';
import { Sparkles } from 'lucide-react';

export default function TopBar() {
  return (
    <div className="relative w-full bg-[#6817FF] text-white text-[13px] md:text-sm overflow-hidden">
      {/* Splash image anchored to the left edge */}
      <img
        src="/spiick_imgs/splash-navbar.webp"
        alt=""
        aria-hidden="true"
        className="absolute left-0 top-0 h-full w-auto pointer-events-none select-none"
      />

      <div className="relative max-w-[1180px] mx-auto pl-[100px] sm:pl-[140px] md:pl-[160px] pr-6 py-3 md:py-3.5 flex items-center justify-center gap-2">
        <Sparkles className="w-4 h-4 text-white/90 shrink-0" strokeWidth={2.2} />
        <p className="font-medium tracking-wide">
          Shaping the future of books, language learning with AI
        </p>
      </div>
    </div>
  );
}
